document.addEventListener('DOMContentLoaded', function () {
  var debounceTimer;

  function syncHeight() {
    document.querySelectorAll('[data-htu-wrap]').forEach(function (wrap) {
      var body = wrap.closest('.htu__body');
      if (!body) return;
      var stepsCol = body.querySelector('.htu__steps-col');
      if (!stepsCol) return;
      if (window.innerWidth >= 768) {
        stepsCol.style.minHeight = wrap.offsetHeight + 'px';
        stepsCol.style.height = '';
      } else {
        stepsCol.style.height = '';
        stepsCol.style.minHeight = '';
      }
    });
  }

  syncHeight();

  window.addEventListener('resize', function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncHeight, 150);
  });

  document.querySelectorAll('[data-htu-wrap]').forEach(function (wrap) {
    var video = wrap.querySelector('.htu__video');
    if (!video) return;

    var muteBtn = wrap.querySelector('.htu__mute-btn');

    wrap.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        wrap.classList.add('htu__video-wrap--playing');
      } else {
        video.pause();
        wrap.classList.remove('htu__video-wrap--playing');
      }
    });

    video.addEventListener('ended', function () {
      wrap.classList.remove('htu__video-wrap--playing');
    });

    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        wrap.classList.toggle('htu__video-wrap--muted', video.muted);
      });
    }
  });
});
